<template>
  <div class="py-1">
    <simple-label
      :id="name"
      :label="label"
      :label-info="labelInfo"
      :required="required"
    ></simple-label>
    <select
      :id="name"
      :name="name"
      :class="{ danger: $parent.form.errors.has(name) }"
      :required="required"
      :value="value"
      @change="onChange"
      @input="emit"
      @blur="emit"
    >
      <!--            <option disabled value="" v-text="i18n.application.choose" class="text-gray-700"></option>-->
      <option
        v-for="item in options"
        :value="item.id"
        :key="item.id"
        v-text="item.label"
      ></option>
    </select>
    <span class="help danger">
      <span
        v-if="useForm && $parent.form.errors.has(name)"
        v-text="$parent.form.errors.get(name)"
      ></span>
    </span>
  </div>
</template>

<script>
import SimpleLabel from "./SimpleLabel";

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    labelInfo: {
      type: String,
      default: "",
      required: false,
    },
    value: {
      type: [String, Number],
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  components: { SimpleLabel },
  mixins: [],
  data: function () {
    return {};
  },
  methods: {
    emit(ev) {
      this.$emit("input", ev.target.value);
    },
    onChange() {
      if (this.useForm) {
        this.$parent.form.errors.clear(name);
      }
    },
  },
  computed: {
    useForm() {
      return this.$parent.form !== undefined;
    },
  },
  mounted() {},
};
</script>

<style></style>
